// extracted by mini-css-extract-plugin
module.exports = {"categories":"skills_categories__3-TEt","category_tag":"skills_category_tag__236MC","skills_display":"skills_skills_display__3P-TJ","subheading":"skills_subheading__1WYUZ"};